import { get } from 'lodash'
import PropTypes from 'prop-types'

import defaultProps from '@/components/Form/defaultProps'
import Field from '@/components/Form/Field'
import propTypes from '@/components/Form/propTypes'
import cn from '@/utilities/cn'

import './index.scss'

/**
 * @example
 * <Checkbox.Input
 *   description={<FormattedMessage id="someDescription" defaultMessage="Some Checkbox" />}
 *   id="someField"
 *   label={<FormattedMessage id="someLabel" defaultMessage="Some Label" />}
 *   name="someField"
 *   required
 *   value="true"
 *   labelLocation="after"
 * />
 */
const Input = ({ className, onChange, label, labelLocation, ...props }: any) => (
  <Field
    {...props}
    label={label || <span />}
    labelLocation="after"
    className={cn('form__checkbox-input', className, labelLocation === 'after' ? 'label-after' : 'label-before')}
    render={({ formik, ...field }: any) => {
      const name = field.name
      const values = get(formik.values, name, [])

      return (
        <input
          {...field}
          checked={Array.isArray(values) ? values.includes(field.value) : values === field.value}
          onBlur={formik.handleBlur}
          onChange={handleChange(formik, name, values, onChange)}
          type="checkbox"
        />
      )
    }}
  />
)

const handleChange = (formik: any, name: any, values: any, onChange: any) => {
  return (e: any) => {
    if (onChange && Array.isArray(values)) {
      onChange(e)
    } else if (onChange) {
      return onChange(e, formik)
    }

    const { checked, value } = e.target

    if (Array.isArray(values)) {
      if (checked) {
        values.push(value)
      } else {
        values.splice(values.indexOf(value), 1)
      }

      formik.setFieldValue(name, values)
    } else {
      formik.setFieldValue(name, checked ? value : null)
    }
  }
}

Input.displayName = 'Input'

Input.propTypes = {
  ...propTypes,
  // redefine `id` prop in order to make it required
  id: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  showErrors: PropTypes.bool,
  title: PropTypes.string
}

Input.defaultProps = {
  ...defaultProps,
  labelLocation: 'after'
}

export default Input
